import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { CustomAttributes } from "components/CustomAttributes/CustomAttributes";
import { Tooltip } from "components/Tooltips/Tooltip";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { KeyValuePair } from "utilities/objects";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    boxWrapper: {
      borderRadius: "8px",
      boxShadow: "0px 1px 1px 0px rgba(154, 147, 147, 0.25)",
      border: `1px solid ${theme.gray200}`,
      fontSize: "14px",
      background: theme.white00,
    },
    header: {
      padding: theme.spacing(6, 8),
      backgroundColor: theme.gray50,
      fontWeight: 500,
      color: theme.gray800,
      boxShadow: `0px 1px 0px 0px ${theme.gray100}`,
      borderRadius: "8px 8px 0 0",
    },
    item: {
      padding: theme.spacing(8, 12),
      display: "flex",
      justifyContent: "space-between",
      boxShadow: `0px 1px 0px 0px ${theme.gray100}`,
      "&:last-of-type": {
        boxShadow: "none",
        borderRadius: "0 0 8px 8px",
      },
    },
    itemName: { color: theme.gray500, width: "50%" },
    itemValue: {
      color: theme.gray800,
      gap: theme.spacing(5),
      fontWeight: 500,
      maxWidth: "50%",
      flexWrap: "wrap",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
    attributesContainer: {
      maxWidth: "50%",
    },
  }),
);

interface Props {
  name: string;
  description: string;
  labels: KeyValuePair[];
}

export const BasicSettings = ({ name, description, labels }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <section className={classes.boxWrapper}>
      <header className={classes.header}>
        {message({ id: "basicSettings" })}
      </header>
      <div className={classes.item}>
        <span className={classes.itemName}>
          {message({ id: "tierSetName" })}
        </span>

        <div className={classes.itemValue}>
          <Tooltip text={name}>
            <span>{name}</span>
          </Tooltip>
        </div>
      </div>
      <div className={classes.item}>
        <span className={classes.itemName}>
          {message({ id: "tierSetDescription" })}
        </span>
        <div className={classes.itemValue}>
          <Tooltip text={description}>
            <span>{description}</span>
          </Tooltip>
        </div>
      </div>
      <div className={classes.item}>
        <span className={classes.itemName}>
          {message({ id: "customAttributes" })}
        </span>
        <div className={classes.attributesContainer}>
          <CustomAttributes attributes={labels} />
        </div>
      </div>
    </section>
  );
};
